import { useEffect, useState } from 'react'

const triggerStorageEvent = (key: string, value: any) => {
  window.dispatchEvent(
    new StorageEvent('storage', {
      key,
      newValue: JSON.stringify(value)
    })
  )
}

export function useLocalStorage<T>(key: string, initialValue: T | (() => T)) {
  const [value, setValue] = useState<T>(() => {
    const jsonValue = localStorage.getItem(key)
    if (jsonValue) {
      return JSON.parse(jsonValue)
    }
    if (typeof initialValue === 'function') {
      return (initialValue as () => T)()
    }
    return initialValue
  })

  const setValueAndTriggerEvent = (newValue: T | ((val: T) => T)) => {
    setValue((prevValue) => {
      const nextValue = typeof newValue === 'function' ? (newValue as (val: T) => T)(prevValue) : newValue

      localStorage.setItem(key, JSON.stringify(nextValue))
      triggerStorageEvent(key, nextValue)

      return nextValue
    })
  }

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValueAndTriggerEvent] as const
}
